export default __webpack_public_path__ + "static/media/bgheader.ad91e033.mp4";